import ProductsList from '../../components/products/ProductsList';
import { PageWrapper, PageContainer } from '../../components/common/PageWrapper.styles';
import { productsPageClass } from './ProductsPage.styles';

const ProductsPage: React.FC = () => {
    return (
        <PageWrapper>
            <PageContainer className={productsPageClass}>
                <ProductsList />
            </PageContainer>
        </PageWrapper>
    );
};

export default ProductsPage;
